import type { AnyFieldApi } from "@tanstack/react-form"
import React from "react"

import { formErrorMessage } from "@/utils/forms"

const FieldInfo = ({ field }: { field: AnyFieldApi }) => {
  const messages = field.state.meta.errors
    .map(formErrorMessage)
    .filter((message): message is string => message !== null)

  return (
    <>
      {messages.length > 0 && (
        <em className="text-sm">{messages.join(", ")}</em>
      )}
      {field.state.meta.isValidating && (
        <em className="text-sm">Validating...</em>
      )}
    </>
  )
}

export default FieldInfo
